import { motion } from "framer-motion";
import Image from "next/image";

import MaxWidthWrapper from "@/components/shared/max-width-wrapper";
import * as m from "@/paraglide/messages";
const technos = [
  {
    title: "ARYA Crypto works with Binance",
    href: "https://binance.com",
    icon: "/images/exchanges/binance.svg",
  },
  {
    title: "ARYA Crypto works with Coinbase",
    href: "https://coinbse.com",
    icon: "/images/exchanges/coinbase.svg",
  },
  {
    title: "ARYA Crypto works with Kraken",
    href: "https://kraken.com",
    icon: "/images/exchanges/kraken.svg",
  },
  {
    title: "ARYA Crypto works with OKX",
    href: "https://okx.com",
    icon: "/images/exchanges/okx.svg",
  },
  {
    title: "ARYA Crypto works with Gateio",
    href: "https://gate.io",
    icon: "/images/exchanges/gate.svg",
  },
  {
    title: "ARYA Crypto works with Bitget",
    href: "https://bitget.com",
    icon: "/images/exchanges/bitget.svg",
  },
];
const container = {
  hidden: { opacity: 0, y: -20 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.6,
      staggerChildren: 0.2,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: -20 },
  show: { opacity: 1, y: 0 },
};
export default function Powered() {
  return (
    <motion.section
      className="pt-8 lg:pt-14 text-muted-foreground"
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ amount: 0.5, once: true }}
    >
      <MaxWidthWrapper>
        <h2 className="text-center dark:text-background text-sm font-semibold uppercase tracking-wide">
          {m.Compatible_with()}
        </h2>

        <motion.div
          className="mt-4 mb-4 lg:mt-8 flex flex-wrap items-center justify-center gap-10 gap-y-4 lg:gap-y-8 lg:gap-16"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ amount: 0.5, once: true }}
        >
          {technos.map((feature) => (
            <motion.div key={feature.title} variants={item}>
              <Image
                alt={feature.title}
                src={feature.icon}
                height={30}
                width={10}
                className="h-4 lg:h-8 w-auto"
              />
            </motion.div>
          ))}
        </motion.div>
      </MaxWidthWrapper>
    </motion.section>
  );
}
